import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  errorText: {
    textAlign: 'right',
    color: 'red',
  },
}));

const AppSelect = ({ ...props }) => {
  const classes = useStyles();

  const handleChange = (event) => {
    onChange(event);
  };

  const handleBlur = (event) => {
    onBlur(event);
  };

  const handleClick = (event) => {
    onClick(event);
  };

  const {
    label,
    options,
    name,
    error,
    value,
    errorMessage,
    onChange,
    onBlur,
    onClick,
  } = props;

  return (
    <FormControl
      variant="outlined"
      size="small"
      style={{ width: '100%' }}
      error={error}
    >
      <InputLabel id={label}>{label}</InputLabel>
      <Select
        labelId={label}
        name={name}
        label={label}
        value={value}
        IconComponent={KeyboardArrowDownIcon}
        onChange={handleChange}
        onClick={handleClick}
        onBlur={handleBlur}
        MenuProps={{
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        }}
      >
        {options.map((option, key) => (
          <MenuItem
            value={option.id}
            key={key}
            data-cy={option.name.split(' ').join('')}
          >
            {option.name}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText className={classes.errorText}>
        {errorMessage}
      </FormHelperText>
    </FormControl>
  );
};

AppSelect.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array,
  name: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.string,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
};

export default AppSelect;
